import { render } from "./UpdateGuiTheme.vue?vue&type=template&id=46bdfae3&scoped=true"
import script from "./UpdateGuiTheme.vue?vue&type=script&lang=js"
export * from "./UpdateGuiTheme.vue?vue&type=script&lang=js"

import "./UpdateGuiTheme.vue?vue&type=style&index=0&id=46bdfae3&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46bdfae3"]])

export default __exports__